import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';

import { loadTransaction } from 'actions';
import { buildSearchParams } from 'utils';
import { allCitiesSelector, bikeTypesSelector } from 'selectors';

import { redirect } from 'widgets/I18nLink';
import Preloader from 'widgets/Preloader';
import ShareLinks from 'widgets/ShareLinks';
import SubscribeFormSection from 'widgets/SubscribeFormSection';
import BookingResultScreen from 'widgets/BookingResultScreen';

import './transaction.css';

export class TransactionPage extends Component {
  constructor(...args) {
    super(...args);

    this.goBackHandler = this.onGoBack.bind(this);
    this.loadDataTimeout = null;

    this.state = {
      searchParams: {}
    };
  }

  componentDidMount() {

    // ^^^ why don't we load this on server?
    this.loadData(this.props);

    this.setState({
      searchParams: buildSearchParams(this.props.location.query)
    });
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);

    if (this.props.location.search !== nextProps.location.search) {
      this.setState({
        searchParams: buildSearchParams(nextProps.location.query)
      });
    }
  }

  componentWillUnmount() {
    this.clearLoadDataTimeout();
  }

  loadData(props) {
    const { transaction, params: { transactionUid } } = props;

    if (transaction.error || transaction.isFetching) {
      return;
    }

    if (transaction.item && transaction.item.invoiceId === transactionUid) {

      // WTF is this?
      if (transaction.item.status === 'processing' && !transaction.item.isConfirmationNeeded) {
        this.clearLoadDataTimeout();
        this.loadDataTimeout = setTimeout(() => {
          this.loadDataTimeout = null;
          this.props.loadTransaction(transactionUid);
        }, 2000); // Where does this timeout come from?
      }

      if (!!window.gtag && (transaction.item.status === 'paid')) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-806969179/V9VbCJ7Y_oABENu-5YAD',
          transaction_id: transaction.item.invoiceId
        });
        window.gtag('event', 'conversion', {
          send_to: 'AW-16593378555/MSYbCOG10LYZEPu5q-g9',
          transaction_id: transaction.item.invoiceId
        });
      }

      return;
    }

    this.props.loadTransaction(transactionUid);
  }

  clearLoadDataTimeout() {
    if (this.loadDataTimeout) {
      clearTimeout(this.loadDataTimeout);
      this.loadDataTimeout = null;
    }
  }

  onGoBack() {
    const query = Object.assign({}, this.props.location.query);

    const bikeId = query.bikeId;
    if (!bikeId) {
      return;
    }

    delete query.bikeId;

    redirect({
      pathname: `/detail/${bikeId}/`,
      query
    });
  }

  render() {
    const { t, transaction: { isFetching, item: transaction } } = this.props;

    const success = !isFetching && transaction && transaction.status === 'paid';
    const needsConfirmation = !isFetching && transaction && transaction.isConfirmationNeeded;
    const fail = !isFetching && transaction && transaction.status === 'error';

    // How could the second option be true? Neither success nor error? WTF?
    const loading = (isFetching && !transaction) || (transaction && !success && !fail && !needsConfirmation);

    return (
      <div className="transaction-page">
        <Grid>
          <div className="transaction-box">
            {(loading) &&
              <Preloader cubeStyle={{ backgroundColor: '#5080c5' }} />
            }

            {(success || needsConfirmation) &&
              <BookingResultScreen
                success={success}
                needsConfirmation={needsConfirmation}
                order={transaction.order}
                cities={this.props.cities}
                bikeTypes={this.props.bikeTypes}
                contactEmail={this.props.contactEmail}
              />
            }

            {(fail) &&
              <BookingResultScreen
                success={false}
                goBackHandler={this.props.location.query.bikeId && this.goBackHandler}
              />
            }
          </div>

          <div className="transaction-share-links">
            <h3>
              {t('Tell your friends about BikesBooking!')}<br />
              {t('We are happy when you are happy:')}
            </h3>

            <ShareLinks
              title={t('title', { ns: 'meta' })}
              description={t('description', { ns: 'meta' })}
            />
          </div>
        </Grid>

        <SubscribeFormSection />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    transaction: state.order.transaction,
    contactEmail: state.app.siteConfig.contactEmail,
    cities: allCitiesSelector(state),
    bikeTypes: bikeTypesSelector(state)
  };
}

export default connect(mapStateToProps, {
  loadTransaction
})(translate(['translation', 'bikeTypes'])(TransactionPage));



// WEBPACK FOOTER //
// ./src/components/TransactionPage/index.js